module.exports = {
  HOST: '',
  EXAM_HOST: '',
  HOST_ONLINE: '',
  SAS_HOST: '',
  VERSION: '230406',
  VERSION_DATE: '06.04.2023'
}



// WEBPACK FOOTER //
// ./src/config.js